import { render, staticRenderFns } from "./DbiTipTap.vue?vue&type=template&id=9bd1eaaa&"
import script from "./DbiTipTap.vue?vue&type=script&lang=ts&"
export * from "./DbiTipTap.vue?vue&type=script&lang=ts&"
import style0 from "./DbiTipTap.vue?vue&type=style&index=0&id=9bd1eaaa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports